import React from 'react'
import { ErrorBoundary } from '@mc/error-boundary'
import { withI18nContext } from '@mc/i18n'
import { CHECKOUT_I18N_NAMESPACE, i18nInstance } from '../../i18n'
import { NavigationDesktop } from './NavigationDesktop'
import { NavigationMobile } from './NavigationMobile'

const NavigationComp = () => (
  <ErrorBoundary fallback={() => ''}>
    <div className='d-block d-md-none'>
      <NavigationMobile />
    </div>
    <div className='d-none d-md-block'>
      <NavigationDesktop />
    </div>
  </ErrorBoundary>
)

export const Navigation = withI18nContext(i18nInstance, {
  ns: CHECKOUT_I18N_NAMESPACE,
})(NavigationComp)
